var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hl-overlay",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "hl-confirm-card"
  }, [_c('button', {
    staticClass: "hl-close hl-close--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" × ")]), _c('h3', {
    staticClass: "hl-confirm-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("default"), _c('div', {
    staticClass: "hl-confirm-actions"
  }, [_vm._t("actions")], 2)], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }